import { useCallback } from "react"
import { useComputed, useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"
import { userData } from "@signals"
import { useAdminSkuSavingData } from "./index"
import { adminSkuFormData, adminSkuReadyToLunchSkuForm } from "../@signals"


export default function useAdminSkuForm(field="") {
    const isLoading = useSignal(false)
    const localValue = useComputed(() => adminSkuFormData.value[field])

    const { showToast } = useToast()
    const { updateSavingData } = useAdminSkuSavingData()

    const handleChange = useCallback((newValue, newData={}) => {
        adminSkuFormData.value = {
            ...adminSkuFormData.value,
            [field]: newValue,
            ...newData
        }
    }, [])

    const handleSubmit = useCallback(() => {
        adminSkuReadyToLunchSkuForm.value = [
            ...adminSkuReadyToLunchSkuForm.value,
            adminSkuFormData.value.skuID
        ]

        isLoading.value = true

        showToast.promise(postSubmit(`${BACKEND_APIS.SKU_DATA}/update-sku`, {
            skuID: adminSkuFormData.value.skuID,
            brandID: adminSkuFormData.value.brand,
            categoryID: adminSkuFormData.value.category,
            ean: adminSkuFormData.value.ean,
            skuName: adminSkuFormData.value.skuName,
            customerID: userData.value.customerID,
            imageUrl: adminSkuFormData.value.imageURL,
            validated: adminSkuFormData.value.validated,
            availablePricing: adminSkuFormData.value.availablePricing,
            availableMarketplaces: adminSkuFormData.value.availableMarketplaces,
        }), {
            onSuccess: res => {
                postSubmit(`${BACKEND_APIS.ADMIN}/sku/normalize-back-response`, res).then(normalizeRes => {
                    updateSavingData(normalizeRes.skuID, normalizeRes, true)
                    adminSkuReadyToLunchSkuForm.value = [...adminSkuReadyToLunchSkuForm.value.filter(v => v !== normalizeRes.skuID)]
                    adminSkuFormData.value = {}
                }).catch(() => showToast.error("Error Normalize Back response but sku is Updated"))
                isLoading.value = false
                return "SKU Saved"
            },
            onError: res => {
                adminSkuReadyToLunchSkuForm.value = [...adminSkuReadyToLunchSkuForm.value.filter(v => v !== adminSkuFormData.value.skuID)]
                isLoading.value = false
                if (res.status === 403)
                    return "SKU already exists in the database."
            }
        })
    }, [])

    return {
        localValue: localValue.value,
        isLoading: isLoading.value,

        handleChange,
        handleSubmit
    }
}